<template>
    <div>
      <div class="row">
        <div class="col-sm-6">
            <span class="span-title">
              {{ $t('contract_reports.time_from') }} - {{ $t('daily_summary.date') }}
            </span>
            <input
                id="fromDate"
                type="date"
                class="form-control form-control-sm"
                v-model="from"
            />
        </div>
        <div class="col-sm-6">
            <span class="span-title">
              {{ $t('contract_reports.time_to') }} - {{ $t('daily_summary.date') }}
            </span>
            <input
                id="toDate"
                type="date"
                class="form-control form-control-sm"
                v-model="to"
            />
        </div>
      </div>
      <div class="row">
          <span class="span-title">
            {{ $t('contract_reports.sub_reports') }}
          </span>
            <div class="row px-2 ms-2">
                <div
                    v-for="(text, key) in options"
                    :key="key"
                    class="form-check form-check-inline col-sm-2 nopads,"
                >
                    <input
                        class="form-check-input form-check-sm"
                        type="checkbox"
                        :id="'section-' + key"
                        :value="key"
                        :checked="selectedOptions.includes(key)"
                        @change="updateSelection"
                    />
                    <label class="form-check-label" :for="'section-' + key" style="font-size: .9rem">
                        {{ text }}
                    </label>
                </div>
            </div>
      </div>
      <div class="row px-3">
            <div class="form-check form-check-inline form-check-sm">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="selectAll"
                    :checked="isAllChecked"
                    @change="toggleAll"
                />
                <label class="form-check-label" for="selectAll">
                    {{ $t('observations.select_all') }}
                </label>
            </div>
      </div>
        <div class="col-sm-12 d-flex justify-content-end">
            <button class="btn btn-primary form-button" @click.stop="emitSearch">
                {{ $t('common.search') }}
            </button>
        </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import OpenContractFilter from "@/components/contract/OpenContractFilter";
import {timeUtils} from "@/components/mixins/TimeUtils";

export default {
    name: "ContractReportFilter",
    components: {OpenContractFilter},
    mixins: [timeUtils],
    props: {
        reportSections: {
            type: Array,
            default() {
                return [];
            }
        },
        fromDate: {
            type: String,
            default: null
        },
        toDate: {
            type: String,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            to: null,
            from: null,
            selectedOptions: []
        }
    },
    computed: {
        options() {
            return {
                contractCosts: this.$t('contracts.costs'),
                deliveryNotes: this.$t('contract_reports.unload_records.title_notes'),
                tripDeliveries: this.$t('daily_summary.cost_calculated'),
                pavingMethods: this.$t('contract_reports.paving_methods'),
                materials: this.$t('material_reports.title'),
                workReports: this.$t('work_report.materials'),
                workAssignments: this.$t('menu.work_assignment'),
                trips: this.$t('daily_summary.title'),
                trafficControl: this.$t('menu.traffic_control'),
                areaWorkReports: this.$t('contract_reports.area_work_reports'),
                skiTrackReports: this.$t('sports.ski_report_title'),
                observationReport: this.$t('observations.observations'),
                dangerReports: this.$t('danger_report.title'),
                roadSigns: this.$t('contract_reports.road_signs'),
                inspections: this.$t('contract_reports.other_inspections'),
                areaInspections: this.$t('contract_reports.area_inspections'),
                weatherData: this.$t('weather_station.data_title'),
                pavingMeasurements: this.$t('contract_reports.sensor_device_reports.title'),
            }
        },
        isAllChecked() {
            return this.selectedOptions.length === Object.keys(this.options).length;
        },
    },
    watch: {
        toDate() {
            this.to = this.toDate ? this.toDate : this.getYesterday()
        },
        fromDate() {
            this.from = this.fromDate ? this.fromDate : this.getYesterday()
        }
    },
    mounted: function () {
        this.to = this.toDate ? this.toDate : this.getYesterday()
        this.from = this.fromDate ? this.fromDate : this.getYesterday()
        this.selectedOptions = this.reportSections
    },
    methods: {
        updateSelection(event) {
            const item = event.target._value
            const selected = event.target.checked
            if (selected && !this.selectedOptions[item]) {
                this.selectedOptions.push(item)
            }
            if (!selected && this.selectedOptions[item]) {
                this.selectedOptions = this.selectedOptions.filter(opt => opt !== item)
            }
            this.$emit('sectionsUpdated', this.selectedOptions)
        },
        emitSearch: function () {
            if (this.from && this.to) {
                this.$emit('search', {
                        dateTo: this.getEndOfTheDay(this.to).getTime(),
                        dateFrom: new Date(this.from).getTime(),
                    },
                )
            }
        },
        toggleAll() {
            if (!this.isAllChecked) {
                this.selectedOptions = Object.keys(this.options)
            } else {
                this.selectedOptions = []
            }
            this.$emit('sectionsUpdated', this.selectedOptions)
        }
    }
}
</script>
